import {React, useState} from 'react';
import { ButtonSet, Button, Theme, Grid, Loading, Stack,  InlineNotification, TextInput, Column} from '@carbon/react';
import {useForm} from "react-hook-form";
import {yupResolver} from '@hookform/resolvers/yup';
import * as yup from "yup";


const schema_rec_password = yup.object().shape({
  txtCorreo: yup.string().email("Escribe un correo válido.").
                 max(50).required("Este campo es requerido.")
})

const RecuperarPassword = () => {
  let headers = new Headers(); headers.append('Content-Type', 'application/json');
  const [loading, setLoading] = useState(false);
  const [errorRestPass, setErrorRestPass] = useState([]);

  const {register, handleSubmit, formState:{ errors }} = useForm({
    resolver: yupResolver(schema_rec_password)
  });

  const hideMesgRestPass = () => {
      setErrorRestPass({ "showMsg": 0 });
  }
  
  const submitForm = (rpForm) =>{
    setLoading(true);
    const rpReq = {};
    rpReq.Correo = rpForm.txtCorreo;

    fetch(process.env.REACT_APP_URL_SERVICE_RESTABLECER_CONTRASENIA, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(rpReq)
    }).then((res) => res.json()).then((resp) => {
        setErrorRestPass({ "showMsg": 1, "kind":(resp.estatus === 0)?"success":"error", "Mensaje": resp.mensaje})
        setLoading(false);
      });
  };


  return (
    <Theme theme="g100">
      <Loading className={'some-class'} active={loading} withOverlay={true} />
        <div >
          <Grid className="recPass-container">
              <Column lg={16} md={8} sm={4}>
                <h1>¿Olvidaste la contraseña?</h1>
                <br/><br/>
                <form  style={{ maxWidth: '500px' }} onSubmit={handleSubmit(submitForm)} >
                  <Stack gap={5}>
                    <TextInput id="txtCorreo" 
                      type="text" 
                      placeholder="Ingresa tu correo electr&oacute;nico" 
                      labelText="Correo electr&oacute;nico *" 
                      {...register("txtCorreo")}
                      invalid={errors.txtCorreo} 
                      invalidText={errors.txtCorreo?.message}/>
                    <div style={{ marginTop: '1rem'}}>
                      <ButtonSet>
                        <Button type="button" kind="secondary" href="/#/" style={{ maxWidth: '48%' }}>
                          Regresar
                        </Button>
                        &nbsp; &nbsp;
                        <Button type="submit" kind="primary" style={{ maxWidth: '48%' }}>
                          Restablecer contraseña
                        </Button>
                      </ButtonSet>
                    </div>
                  </Stack>
                </form>
                <br/><br/>
                {errorRestPass.showMsg === 1 && 
                  <InlineNotification
                    kind={errorRestPass.kind} style={{ maxWidth: '41%' }}
                    title={errorRestPass.Mensaje}
                    lowContrast={true} 
                    hideCloseButton={false}
                    onClick={hideMesgRestPass}
                  />
                }
              </Column>
              <Column lg={16} md={8} sm={4}> <br/><br/> </Column>
          </Grid>
        </div>
    </Theme>
  );
};

export default RecuperarPassword;